import http from 'plugins/axios';

export default {

  //更新后的查询所有用户信息
  getUserList(data) {
    return http.get({
      url: '/ta/admin/login/send/history',
      data
    })
  },

  historyDetail(data) {
    return http.get({
      url: '/ta/admin/login/send/history/detail',
      data
    })
  },


};
